import React from 'react';
import {Flex} from '/app/src/component'
import style from './style.css'

// if props manual is declare, we dont change active state auto but ask for it from
// parent

/*
    props
        - on
        - manual
        - colorOn: default green
        - colorOff: default red
        - (Maybe more)
*/

class ToogleSwitch extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            on: props.on?true:false,
            manual: props.manual
        }
        this._handleClick = this._handleClick.bind(this)
    }

    _handleClick(event){
        if(!this.state.manual){
            event.target.value = !this.state.on
            this.setState({on: !this.state.on})
        }
        if(this.props.onChange) this.props.onChange(event)
    }
    componentWillReceiveProps(nextProps){
        if(nextProps.on !== undefined){
            this.setState({on: nextProps.on})
        }
    }

    render() {
        const colorOn = this.props.colorOn || '#8fef54';
        const colorOff = this.props.colorOff || 'lightgrey';
        const bgColor = this.state.on ? colorOn : colorOff;
        return(
            <Flex height='30px' onClick={this._handleClick}>
                <label className={style.switch}>
                    <input disabled type="checkbox" checked={this.state.on}/>
                    <span style={{backgroundColor:bgColor}} className={style.slider}></span>
                </label>
            </Flex>
        );
    }
}
export default ToogleSwitch;



// WEBPACK FOOTER //
// src/component/Forms/ToogleSwitch/index.js